import React from 'react';
import BatteryStatus from './BatteryStatus';
import DataMonitoring from './DataMonitoring';

const BatteryBMS = () => {
    // Active route styles 
    let activeStyle = {
        borderBottom: '2px solid #FA6164',
        color: '#FA6164',
        borderRadius: '0',
    };

    return (
        <div className='m-4'>

            <BatteryStatus />

            <DataMonitoring />

        </div>
    );
};

export default BatteryBMS;

